import {
    LaneStatus,
} from 'app/enums/label.enums'
import {
    FormPart,
} from 'app/types/form.types'

import {
    Lane,
} from '../../lanes.types'

const laneInformationFields = ({
    originalStatus,
    getAllowedValues,
}: {
    originalStatus: LaneStatus,
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
}): FormPart<keyof Lane> => {
    return {
        title: 'Lane Information',
        className: 'laneInformation',
        fields: [
            {
                id: 'laneInformation1',
                fields: [
                    {
                        name: 'laneStatus',
                        componentName: 'StatusTransitionSelector',
                        moduleName: 'laneImplementation',
                        allowedValues: getAllowedValues(LaneStatus),
                        originalStatus,
                        useDropdown: true,
                        disabled: true,
                        labelKey: 'LaneOpsInformationDto.laneStatus',
                    },
                    {
                        name: 'endOfLeaseReminderDelay',
                        componentName: 'IntegerInput',
                        labelKey: 'LaneOpsInformationDto.endOfLeaseReminderDelay',
                    },
                    {
                        name: 'billingCompany',
                        componentName: 'BillingCompanyObjectSelector',
                        labelKey: 'LaneUpdateNewDto.billingCompany',
                        required: true,
                    },
                ],
            },
            {
                id: 'laneInformation3',
                fields: [
                    {
                        name: 'laneCommentOps',
                        componentName: 'LongText',
                        labelKey: 'LaneOpsInformationDto.laneCommentOps',
                    },
                    {
                        name: 'skyMindLaneId',
                        componentName: 'IntegerInput',
                        labelKey: 'LaneOpsInformationDto.skyMindLaneId',
                    },
                ],
            },
        ],
    }
}

export default laneInformationFields
